import ShoppableIngredient from '@views/RecipeDetailPage/ShoppableIngredient';

interface Props {
  shoppableTools: {
    title?: string;
    products: Array<any>;
  };
}

const ShoppableTools = ({ shoppableTools }: Props) => {
  return (
    <div className="tw-mt-3">
      <h6 className="tra-text-web-heading-6 tw-text-left tw-mb-0">{shoppableTools?.title}</h6>
      <table className="tw-border-separate tw-border-spacing-y-4">
        <tbody>
          {shoppableTools.products?.map((product, i) => (
            <tr key={`ingredient_${i}`}>
              <td className="tra-text-web-body-s tw-mb-0 tw-pr-2 tw-border-r">1</td>
              <ShoppableIngredient product={product} key={`ingredient_${i}`} />
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};
export default ShoppableTools;
